
if (!String.prototype.ucfirst) {
	String.prototype.ucfirst = function() {
		var str = this;
		if (str.length) {
			str = str.charAt(0).toUpperCase() + str.slice(1);
		}

		return str;
	}
}

if (__PROD__) {
	require('script!fox-core/dist/fox.min.js');
} else {
	require('script!fox-core/dist/fox.js');
}

// shim for IE in particular
if (!('Promise' in window)) {
	window.Promise = fox.Promise;
}

var lib = fox.lib = fox.initDefaultLibrary();

fox.jQuery = require('jquery');
window.jQuery = fox.jQuery;
window.$ = fox.jQuery;

fox.getEnv = function (path) {
	return fox.objectGet(environment, path);
};

fox.setEnv = function (path, value) {
	return fox.objectSet(environment, path, value);
};

fox.createApplication = function (options, env) {
	var wom = this.createEnvironment(lib);
	var app = wom.loadWidget(options.widget || 'App', options || {});

	this.site = app;
	this.wom = app.getWom();
	this.setEnv = app.setEnv.bind(app);
	this.getEnv = app.getEnv.bind(app);
	app.setEnv(env || {});
};

var resources = {};
fox._r = function (alias, path) {
	return resources[alias] || (resources[alias] = path);
};

require('fox-core-resource')(fox);
require('fox-services')(fox);

try {
	var main = require('mc_area_model_promo2');

	if (window.customization) {
		var c11n = window.customization;

		if (fox.isFunction(c11n)) {
			c11n = c11n(fox);
		}

		c11n.resources(fox);
		main(fox, environment && environment.staticUrl);
		c11n.nonResources(fox);
	} else {
		main(fox, environment && environment.staticUrl);
	}

	if (typeof _fox_init_ === 'function') {
		_fox_init_();
	}
} catch (e) {
	if (typeof __blankPage === 'function') {
		__blankPage(e);
	}

	console.error(e);
}



//////////////////
// WEBPACK FOOTER
// ./__app_entry.tmp.js
// module id = 98
// module chunks = 0